<template>
  <Classic v-if="store.payment.bumpSettings.orderBumpStyle === 'classic'" />
  <div v-else class="flex w-full items-center justify-center self-stretch">
    <TemplateOne v-if="store.payment.bumpSettings.bumpTemplate === 'templateOne'" />
    <TemplateTwo v-if="store.payment.bumpSettings.bumpTemplate === 'templateTwo'" />
    <TemplateThree v-if="store.payment.bumpSettings.bumpTemplate === 'templateThree'" />
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { computed } from "vue";

import Classic from "./ClassicStyle.vue";
import TemplateOne from "./TemplateOne.vue";
import TemplateThree from "./TemplateThree.vue";
import TemplateTwo from "./TemplateTwo.vue";

const store = useAppStore();

// Computed property to optimize rendering
const shouldShowBump = computed(() => {
  return store.payment?.paymentType === "product" && store.payment.bumpSettings.enableBump;
});
</script>

<style scoped></style>
